module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAcCAYAAACgXdXMAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAK8AAACvABQqw0mAAAABZ0RVh0Q3JlYXRpb24gVGltZQAwOC8xMi8xMKNAeX0AAAAYdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3Jrc0+zH04AAABISURBVAiZYzgTzvCf4f9c1/9MDH9+MjD9//6RgYnh13cGpv///jEw/f//n4GJAc5CF6NACSMrBwMTE48QAxMDGycD080rVxkAuzlCeewXF4cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client/h_middle.png
// module id = 742
// module chunks = 114